
const m = window.require("load-image");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
